import React from 'react';
import ReactTooltip from 'react-tooltip';
import { FiCheckCircle, FiXCircle, FiAlertCircle } from 'react-icons/fi';
import { IS_QUALIFIED } from 'utils/constants';

export const SCREENER_ANSWERED_STATUS = Object.freeze({
    QUALIFIED: 'qualified',
    DISQUALIFIED: 'disqualified',
    OVER_QUOTA: 'over_quota',
    INCOMPLETE: 'incomplete'
});

/**
 * Qualification outcome of a single screener answer (screener_data row).
 *
 * @param {{ incomplete: number|boolean, is_qualified: number }} screenerAnswer
 * @returns {string} one of SCREENER_ANSWERED_STATUS
 */
export const getScreenerAnsweredStatus = screenerAnswer => {
    if (screenerAnswer.incomplete) return SCREENER_ANSWERED_STATUS.INCOMPLETE;
    if (screenerAnswer.is_qualified == IS_QUALIFIED.YES) return SCREENER_ANSWERED_STATUS.QUALIFIED;
    if (screenerAnswer.is_qualified == IS_QUALIFIED.OVER_QUOTA) return SCREENER_ANSWERED_STATUS.OVER_QUOTA;
    return SCREENER_ANSWERED_STATUS.DISQUALIFIED;
};

/**
 * Icon + tooltip for a screener answer's qualification outcome.
 *
 * @param {string} status one of SCREENER_ANSWERED_STATUS
 * @param {string} tooltipId unique per rendered icon
 * @param {string?} tooltipPlace react-tooltip placement, defaults to 'left'
 */
export function ScreenerAnsweredStatus({ status, tooltipId, tooltipPlace = 'left' }) {
    const icon_style = { margin: '0 8px 1px 0' };
    let icon = null;
    let message = '';
    switch (status) {
        case SCREENER_ANSWERED_STATUS.QUALIFIED:
            icon = <FiCheckCircle data-tip data-for={tooltipId} className="fs-16 color-success" style={icon_style} />;
            message = 'Qualified';
            break;
        case SCREENER_ANSWERED_STATUS.DISQUALIFIED:
            icon = <FiXCircle data-tip data-for={tooltipId} className="fs-16 color-danger" style={icon_style} />;
            message = 'Disqualified';
            break;
        case SCREENER_ANSWERED_STATUS.OVER_QUOTA:
            icon = <FiCheckCircle data-tip data-for={tooltipId} className="fs-16 color-warning" style={icon_style} />;
            message = 'Qualified, Over Quota';
            break;
        case SCREENER_ANSWERED_STATUS.INCOMPLETE:
            icon = <FiAlertCircle data-tip data-for={tooltipId} className="fs-16 color-warning" style={icon_style} />;
            message = 'Incomplete';
            break;
    }

    return (
        <>
            {icon}
            <ReactTooltip id={tooltipId} place={tooltipPlace} effect="solid">
                {message}
            </ReactTooltip>
        </>
    );
}

export default ScreenerAnsweredStatus;
